import styled from "styled-components";
import color from "../../assets/css/colors";

export const FirstCol = styled.div`
    width: 200px;
`;

export const SecondCol = styled.div`
    width: 142px;
`;

export const ThirdCol = styled.div`
    width: 130px;
    position: relative;
`;

export const Space = styled.div`
    width: 46px;
`

export const Legend = styled.p`
    line-height: 1;
    margin: 0;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: ${color.tertiary};
    margin-bottom: 4px;
`;

export const Info = styled.p`
    line-height: 1;
    margin: 0;
    font: normal normal 600 14px/14px Muli;
    letter-spacing: 0.7px;
    color: ${color.grayDark};
    margin-bottom: 17px;
`;